import * as a from "../icons/Add.svg.js";
import * as g from "../icons/AddTab.svg.js";
import * as i from "../icons/Alert.svg.js";
import * as n from "../icons/ArrowLeft.svg.js";
import * as t from "../icons/ArrowRight.svg.js";
import * as p from "../icons/Brackets.svg.js";
import * as e from "../icons/Branch.svg.js";
import * as c from "../icons/Changelog.svg.js";
import * as l from "../icons/Checkmark.svg.js";
import * as f from "../icons/ChevronDown.svg.js";
import * as v from "../icons/ChevronLeft.svg.js";
import * as u from "../icons/ChevronRight.svg.js";
import * as d from "../icons/ChevronUp.svg.js";
import * as L from "../icons/Clipboard.svg.js";
import * as h from "../icons/Close.svg.js";
import * as w from "../icons/CloseTab.svg.js";
import * as k from "../icons/CloseTabs.svg.js";
import * as C from "../icons/Cloud.svg.js";
import * as b from "../icons/CodeFolder.svg.js";
import * as j from "../icons/Cog.svg.js";
import * as D from "../icons/Collection.svg.js";
import * as S from "../icons/Cookie.svg.js";
import * as y from "../icons/DarkMode.svg.js";
import * as A from "../icons/Delete.svg.js";
import * as E from "../icons/Discord.svg.js";
import * as F from "../icons/DocsPage.svg.js";
import * as H from "../icons/Download.svg.js";
import * as R from "../icons/Duplicate.svg.js";
import * as T from "../icons/Edit.svg.js";
import * as U from "../icons/Ellipses.svg.js";
import * as x from "../icons/Email.svg.js";
import * as P from "../icons/Error.svg.js";
import * as G from "../icons/Example.svg.js";
import * as M from "../icons/ExternalLink.svg.js";
import * as N from "../icons/FilterList.svg.js";
import * as O from "../icons/Folder.svg.js";
import * as W from "../icons/GitHub.svg.js";
import * as I from "../icons/GitHubLine.svg.js";
import * as V from "../icons/Globe.svg.js";
import * as B from "../icons/Google.svg.js";
import * as $ from "../icons/Help.svg.js";
import * as J from "../icons/Hide.svg.js";
import * as K from "../icons/History.svg.js";
import * as q from "../icons/House.svg.js";
import * as z from "../icons/Import.svg.js";
import * as Q from "../icons/Info.svg.js";
import * as X from "../icons/Key.svg.js";
import * as Y from "../icons/Leave.svg.js";
import * as Z from "../icons/LightDarkModeToggle.svg.js";
import * as _ from "../icons/LightMode.svg.js";
import * as oo from "../icons/Link.svg.js";
import * as ro from "../icons/Lock.svg.js";
import * as so from "../icons/Logo.svg.js";
import * as mo from "../icons/Magic.svg.js";
import * as ao from "../icons/Markdown.svg.js";
import * as go from "../icons/Menu.svg.js";
import * as io from "../icons/NotAllowed.svg.js";
import * as no from "../icons/Page.svg.js";
import * as to from "../icons/Pencil.svg.js";
import * as po from "../icons/Play.svg.js";
import * as eo from "../icons/Refresh.svg.js";
import * as co from "../icons/Roadmap.svg.js";
import * as lo from "../icons/Scribble.svg.js";
import * as fo from "../icons/Search.svg.js";
import * as vo from "../icons/Server.svg.js";
import * as uo from "../icons/Settings.svg.js";
import * as Lo from "../icons/Show.svg.js";
import * as ho from "../icons/Sort.svg.js";
import * as wo from "../icons/Terminal.svg.js";
import * as ko from "../icons/Trash.svg.js";
import * as Co from "../icons/Unlock.svg.js";
import * as bo from "../icons/Unwatch.svg.js";
import * as jo from "../icons/Upload.svg.js";
import * as Do from "../icons/User.svg.js";
import * as So from "../icons/UserSwitch.svg.js";
import * as yo from "../icons/Users.svg.js";
import * as Ao from "../icons/Versions.svg.js";
import * as Eo from "../icons/Wallet.svg.js";
import * as Fo from "../icons/Watch.svg.js";
import * as Ho from "../icons/Workspace.svg.js";
import * as Ro from "../icons/programming-framework-angular.svg.js";
import * as To from "../icons/programming-framework-astro.svg.js";
import * as Uo from "../icons/programming-framework-laravel.svg.js";
import * as xo from "../icons/programming-framework-nextdotjs.svg.js";
import * as Po from "../icons/programming-framework-react.svg.js";
import * as Go from "../icons/programming-framework-vuedotjs.svg.js";
import * as Mo from "../icons/programming-language-c.svg.js";
import * as No from "../icons/programming-language-clojure.svg.js";
import * as Oo from "../icons/programming-language-csharp.svg.js";
import * as Wo from "../icons/programming-language-css3.svg.js";
import * as Io from "../icons/programming-language-dart.svg.js";
import * as Vo from "../icons/programming-language-go.svg.js";
import * as Bo from "../icons/programming-language-html5.svg.js";
import * as $o from "../icons/programming-language-http.svg.js";
import * as Jo from "../icons/programming-language-java.svg.js";
import * as Ko from "../icons/programming-language-javascript.svg.js";
import * as qo from "../icons/programming-language-json.svg.js";
import * as zo from "../icons/programming-language-kotlin.svg.js";
import * as Qo from "../icons/programming-language-node.svg.js";
import * as Xo from "../icons/programming-language-objc.svg.js";
import * as Yo from "../icons/programming-language-ocaml.svg.js";
import * as Zo from "../icons/programming-language-php.svg.js";
import * as _o from "../icons/programming-language-powershell.svg.js";
import * as or from "../icons/programming-language-python.svg.js";
import * as rr from "../icons/programming-language-r.svg.js";
import * as sr from "../icons/programming-language-ruby.svg.js";
import * as mr from "../icons/programming-language-rust.svg.js";
import * as ar from "../icons/programming-language-scala.svg.js";
import * as gr from "../icons/programming-language-shell.svg.js";
import * as ir from "../icons/programming-language-swift.svg.js";
import * as nr from "../icons/programming-language-typescript.svg.js";
import * as tr from "../icons/programming-script-code.svg.js";
import * as pr from "../icons/programming-tool-git.svg.js";
import * as er from "../icons/programming-tool-tailwindcss.svg.js";
import * as cr from "../logos/Adonisjs.svg.js";
import * as lr from "../logos/Docusaurus.svg.js";
import * as fr from "../logos/Dotnet.svg.js";
import * as vr from "../logos/Elysiajs.svg.js";
import * as ur from "../logos/Express.svg.js";
import * as dr from "../logos/Fastapi.svg.js";
import * as Lr from "../logos/Fastify.svg.js";
import * as hr from "../logos/Go.svg.js";
import * as wr from "../logos/Hono.svg.js";
import * as kr from "../logos/Laravel.svg.js";
import * as Cr from "../logos/Litestar.svg.js";
import * as br from "../logos/Nestjs.svg.js";
import * as jr from "../logos/Nextjs.svg.js";
import * as Dr from "../logos/Nitro.svg.js";
import * as Sr from "../logos/Nuxt.svg.js";
import * as yr from "../logos/Openapi.svg.js";
import * as Ar from "../logos/Platformatic.svg.js";
import * as Er from "../logos/React.svg.js";
import * as Fr from "../logos/Rust.svg.js";
import * as Hr from "../logos/Svelte.svg.js";
import * as Rr from "../logos/Vue.svg.js";
const s = /* @__PURE__ */ Object.assign({
  "../icons/Add.svg": a,
  "../icons/AddTab.svg": g,
  "../icons/Alert.svg": i,
  "../icons/ArrowLeft.svg": n,
  "../icons/ArrowRight.svg": t,
  "../icons/Brackets.svg": p,
  "../icons/Branch.svg": e,
  "../icons/Changelog.svg": c,
  "../icons/Checkmark.svg": l,
  "../icons/ChevronDown.svg": f,
  "../icons/ChevronLeft.svg": v,
  "../icons/ChevronRight.svg": u,
  "../icons/ChevronUp.svg": d,
  "../icons/Clipboard.svg": L,
  "../icons/Close.svg": h,
  "../icons/CloseTab.svg": w,
  "../icons/CloseTabs.svg": k,
  "../icons/Cloud.svg": C,
  "../icons/CodeFolder.svg": b,
  "../icons/Cog.svg": j,
  "../icons/Collection.svg": D,
  "../icons/Cookie.svg": S,
  "../icons/DarkMode.svg": y,
  "../icons/Delete.svg": A,
  "../icons/Discord.svg": E,
  "../icons/DocsPage.svg": F,
  "../icons/Download.svg": H,
  "../icons/Duplicate.svg": R,
  "../icons/Edit.svg": T,
  "../icons/Ellipses.svg": U,
  "../icons/Email.svg": x,
  "../icons/Error.svg": P,
  "../icons/Example.svg": G,
  "../icons/ExternalLink.svg": M,
  "../icons/FilterList.svg": N,
  "../icons/Folder.svg": O,
  "../icons/GitHub.svg": W,
  "../icons/GitHubLine.svg": I,
  "../icons/Globe.svg": V,
  "../icons/Google.svg": B,
  "../icons/Help.svg": $,
  "../icons/Hide.svg": J,
  "../icons/History.svg": K,
  "../icons/House.svg": q,
  "../icons/Import.svg": z,
  "../icons/Info.svg": Q,
  "../icons/Key.svg": X,
  "../icons/Leave.svg": Y,
  "../icons/LightDarkModeToggle.svg": Z,
  "../icons/LightMode.svg": _,
  "../icons/Link.svg": oo,
  "../icons/Lock.svg": ro,
  "../icons/Logo.svg": so,
  "../icons/Magic.svg": mo,
  "../icons/Markdown.svg": ao,
  "../icons/Menu.svg": go,
  "../icons/NotAllowed.svg": io,
  "../icons/Page.svg": no,
  "../icons/Pencil.svg": to,
  "../icons/Play.svg": po,
  "../icons/Refresh.svg": eo,
  "../icons/Roadmap.svg": co,
  "../icons/Scribble.svg": lo,
  "../icons/Search.svg": fo,
  "../icons/Server.svg": vo,
  "../icons/Settings.svg": uo,
  "../icons/Show.svg": Lo,
  "../icons/Sort.svg": ho,
  "../icons/Terminal.svg": wo,
  "../icons/Trash.svg": ko,
  "../icons/Unlock.svg": Co,
  "../icons/Unwatch.svg": bo,
  "../icons/Upload.svg": jo,
  "../icons/User.svg": Do,
  "../icons/UserSwitch.svg": So,
  "../icons/Users.svg": yo,
  "../icons/Versions.svg": Ao,
  "../icons/Wallet.svg": Eo,
  "../icons/Watch.svg": Fo,
  "../icons/Workspace.svg": Ho,
  "../icons/programming-framework-angular.svg": Ro,
  "../icons/programming-framework-astro.svg": To,
  "../icons/programming-framework-laravel.svg": Uo,
  "../icons/programming-framework-nextdotjs.svg": xo,
  "../icons/programming-framework-react.svg": Po,
  "../icons/programming-framework-vuedotjs.svg": Go,
  "../icons/programming-language-c.svg": Mo,
  "../icons/programming-language-clojure.svg": No,
  "../icons/programming-language-csharp.svg": Oo,
  "../icons/programming-language-css3.svg": Wo,
  "../icons/programming-language-dart.svg": Io,
  "../icons/programming-language-go.svg": Vo,
  "../icons/programming-language-html5.svg": Bo,
  "../icons/programming-language-http.svg": $o,
  "../icons/programming-language-java.svg": Jo,
  "../icons/programming-language-javascript.svg": Ko,
  "../icons/programming-language-json.svg": qo,
  "../icons/programming-language-kotlin.svg": zo,
  "../icons/programming-language-node.svg": Qo,
  "../icons/programming-language-objc.svg": Xo,
  "../icons/programming-language-ocaml.svg": Yo,
  "../icons/programming-language-php.svg": Zo,
  "../icons/programming-language-powershell.svg": _o,
  "../icons/programming-language-python.svg": or,
  "../icons/programming-language-r.svg": rr,
  "../icons/programming-language-ruby.svg": sr,
  "../icons/programming-language-rust.svg": mr,
  "../icons/programming-language-scala.svg": ar,
  "../icons/programming-language-shell.svg": gr,
  "../icons/programming-language-swift.svg": ir,
  "../icons/programming-language-typescript.svg": nr,
  "../icons/programming-script-code.svg": tr,
  "../icons/programming-tool-git.svg": pr,
  "../icons/programming-tool-tailwindcss.svg": er
}), m = /* @__PURE__ */ Object.assign({
  "../logos/Adonisjs.svg": cr,
  "../logos/Docusaurus.svg": lr,
  "../logos/Dotnet.svg": fr,
  "../logos/Elysiajs.svg": vr,
  "../logos/Express.svg": ur,
  "../logos/Fastapi.svg": dr,
  "../logos/Fastify.svg": Lr,
  "../logos/Go.svg": hr,
  "../logos/Hono.svg": wr,
  "../logos/Laravel.svg": kr,
  "../logos/Litestar.svg": Cr,
  "../logos/Nestjs.svg": br,
  "../logos/Nextjs.svg": jr,
  "../logos/Nitro.svg": Dr,
  "../logos/Nuxt.svg": Sr,
  "../logos/Openapi.svg": yr,
  "../logos/Platformatic.svg": Ar,
  "../logos/React.svg": Er,
  "../logos/Rust.svg": Fr,
  "../logos/Svelte.svg": Hr,
  "../logos/Vue.svg": Rr
}), Tr = (o) => {
  const r = `../icons/${o}.svg`;
  return s[r] ? s[r] : (console.warn(`Could not find icon: ${o}`), null);
}, Ur = (o) => {
  const r = `../logos/${o}.svg`;
  return m[r] ? m[r] : (console.warn(`Could not find icon: ${o}`), null);
};
export {
  Tr as getIcon,
  Ur as getLogo
};
